import React, { FC } from 'react'
import styles from './ReviewGallery.module.scss'
import cn from 'classnames'
import { ISlide } from '../../types'
import Image from '../../common/Image/Image'
import PlayIcon from '../../../public/static/icons/play.svg'
import { useRouter } from 'next/router'

const ReviewGallery: FC<{ id: string; elements: ISlide[]; maxCount: number }> =
  ({ id, elements, maxCount }) => {
    const router = useRouter()
    const moreElements =
      elements.length > maxCount ? elements.length - maxCount : null

    function handlerClick(id: string, fileId: string) {
      router.push(
        {
          pathname: router.pathname,
          query: { ...router.query, detailReview: id, file: fileId },
        },
        null,
        {
          scroll: false,
          shallow: true,
        },
      )
    }

    return (
      <ul className={styles.list}>
        {elements.slice(0, maxCount).map(({ src, type, id: fileId }, index) => {
          const showMore = moreElements && index === maxCount - 1
          return (
            <li
              key={`${id}-${src}-${index}`}
              className={cn(
                styles.item,
                (showMore || type === 'video') && styles['item--relative'],
              )}
              onClick={() => handlerClick(id, fileId)}
            >
              <Image
                src={src}
                width={150}
                height={170}
                className={styles.img}
                alt={`Слайд - ${index}`}
              />
              {type === 'video' && (
                <div className={styles.iconContainer}>
                  <PlayIcon />
                </div>
              )}
              {showMore && <div className={styles.more}>+{moreElements}</div>}
            </li>
          )
        })}
      </ul>
    )
  }

export default ReviewGallery
